import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import parse from 'html-react-parser';
import "./grid.css";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import { Input, Box, HStack, Flex, Center, Text } from "@chakra-ui/react";
import { ChevronUpIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { 
  MdOutlineVisibility as IcoDetail, 
  MdOutlineFilterAltOff as IcoClearFilter,
} from 'react-icons/md';
import { useToast } from "@chakra-ui/react";
// Components
import CommonButton from "../../../common/button/button";
// Actions
import * as mainActions from "../../../../redux/actions/main";
// Utils
import { getToastOpt } from '../../../../utils/utils';
import { 
  formatDateToMadridTime, 
  formatAccessLevels,
  formatPushNotificationActions,
  formatDaysOfWeek,
} from '../../../../utils/formatters';
// Date picker
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';
registerLocale('es', es)

const MaintenanceViewGrid = ({ 
  primaryKey,
  primaryNameKey,
  config,
     // columns (object)
     // filters (object)
     // sorters (object)
     // hardFilters (object)
     // enablePagination (bool)
     // marginTop (string)
     // buttonDetailVisible (bool)
     // forceRefreshDataAtBegining (bool)
     // title (string)
     // widthSizeGapAtEnd (int)
     // floatComponent (jsx)
  actions, 
  reducerName,
  setIsLoading,
  setRefreshData,
  refreshData,
  itemNameSingular,
  isSearcher = false,
  isMultiRowSelection = false,
  allowSelection = true,
  defaultDetailPathKey = 'detail',
  page = null,
}) => {
  const dispatch = useDispatch();
  const gridParentRef = useRef(null);
  const gridRef = useRef(null);
  const navigate = useNavigate();
  const toast = useToast();
  // States
  const [sizeGrid, setSizeGrid] = useState({w: 0, h: 0});
  const [initialSizeGrid, setInitialSizetGrid] = useState({w: 0, h: 0});
  const [initialWindowInnerSize,] = useState({w: window.innerWidth, h: window.innerHeight});
  const [activePage, setActivePage] = useState(1);
  const [timeoutFiltering, setTimeoutFiltering] = useState(null);
  const [initializedFilters, setInitializedFilters] = useState(false);
  const [initializedSorters, setInitializedSorters] = useState(false);
  // Selectors
  const menuWidth = useSelector((state) => state.mainReducer.menuWidth);
  const currentPage = useSelector(state => state.mainReducer.currentPage);
  const breadscrum = useSelector(state => !!state.mainReducer.breadscrum[currentPage] ? state.mainReducer.breadscrum[currentPage] : []);
  let data = useSelector((state) => state[reducerName].data);
  const initializedData = useSelector((state) => state[reducerName].initializedData);
  let rowsCount = useSelector(state => state[reducerName].count);
  let maxRowsPerScreen = useSelector(state => state[reducerName].limit);
  // Searcher
  const prefixSearcher = isSearcher ? 'searcher_' : '';
  const selectedRows = useSelector((state) => state[reducerName][prefixSearcher + 'selectedRows']);
  let filters = useSelector(state => state[reducerName][prefixSearcher + 'filters']);
  let sorters = useSelector(state => state[reducerName][prefixSearcher + 'sorters']);
  const initialSorters = useSelector(state => state[reducerName][prefixSearcher + 'initialSorters']);

  // console.log('rowsCount', rowsCount);
  // console.log('maxRowsPerScreen', maxRowsPerScreen);
  // console.log('filters', filters);
  // console.log('sorters', sorters);

  // Set vars
  let numberOfPages = maxRowsPerScreen > 0 ? Math.ceil(rowsCount / maxRowsPerScreen) : 1;
  if (!numberOfPages || numberOfPages < 1) numberOfPages = 1;
  if (sizeGrid.h <= 0) {
    data = [];
    rowsCount = 0;
    numberOfPages = 1;
  }
  // Safety: never render more rows than the page limit when pagination is on
  if (config.enablePagination && maxRowsPerScreen > 0 && data.length > maxRowsPerScreen) {
    data = data.slice(0, maxRowsPerScreen);
  }
  const heightPagination = config.enablePagination ? 50 : 0;
  const eyeColumnWidth = `40px`
  const defaultMinWidth = "90px";

  /*
   * Use effects
   */

  useEffect(() => {

    if (!initializedData || config.forceRefreshDataAtBegining) {
      // Clean selected rows, filters and sorters
      if (selectedRows.length > 0) {
        dispatch(actions.setSelectedRows([], isSearcher));
      }
      if (Object.keys(filters).length > 0) {
        filters = {};
        dispatch(actions.setFilters({}, isSearcher));
      }
      if (Object.keys(sorters).length > 0) {
        sorters = !!initialSorters ? initialSorters : {};
        dispatch(actions.setSorters(sorters, isSearcher));
      }
      // Get data
      getData();
      dispatch(actions.setInitializedData(true));
    }
    return () => {
      if (timeoutFiltering !== null) clearTimeout(timeoutFiltering);
    };
  }, []);

  useEffect(() => {
    if (!refreshData) return;

    // Get data
    getData();

    setRefreshData(false);

  }, [refreshData]);

  useEffect(() => {
    if (!config.enablePagination) return;
    if (!initializedSorters) {
      setInitializedSorters(true);
      return;
    }
    getData();
  }, [sorters, activePage]);

  useEffect(() => {
    if (!config.enablePagination) return;
    if (!initializedFilters) {
      setInitializedFilters(true);
      return;
    }
    // Reset to first page when filters change; activePage effect will refetch
    if (activePage !== 1) {
      setActivePage(1);
      return;
    }
    // console.log('useEffect > filters', filters);
    handleFilteringTimeout();
  }, [filters]); 

  /*
  * Resize control
  */

  useEffect(() => {
    if (!gridParentRef) return;
    const h = gridParentRef.current.clientHeight;
    const w = gridParentRef.current.clientWidth;
    setSizeGrid({h, w});
    setInitialSizetGrid({h, w});
  }, [gridParentRef]);

  useEffect(() => {
    if (menuWidth == 0) return;
    if (!initialSizeGrid) return;
    window.addEventListener("resize", onResize);
    resize();
    return () => window.removeEventListener("resize", onResize);
  }, [initialSizeGrid, menuWidth]);   
  
  const onResize = (e) => {
    // console.log("onResize", e);
    resize();
  };

  const resize = () => {
    // Set new H
    const diffH = Math.abs(initialWindowInnerSize.h - window.innerHeight);
    const factorH = window.innerHeight >= initialWindowInnerSize.h ? 1 : -1;
    const newH = initialSizeGrid.h + (diffH * factorH);
    // Set new W
    const widthSizeGapAtEnd = !!config.widthSizeGapAtEnd ? config.widthSizeGapAtEnd : 0;
    const newW = window.innerWidth - menuWidth - 20 - widthSizeGapAtEnd;
    // console.log('resize', newW);
    // Set new size
    setSizeGrid({h: newH, w: newW});
  };  

  /*
   * Methods
   */

  const getData = async () => {

    // Set filters
    let filters_params = {};
    for (const key in filters) {
      if (!!filters[key]) {
        let value = filters[key];
        const found = config.columns.find(el => el.name === key);
        if (!!found) {
          const type = found.header.dataType;
          if (type === 'bool' || type === 'boolean') {
            if (value.toLowerCase()=="s" || value.toLowerCase()=="si") {
              value = true;
            } else {
              value = false;
            }
          }
          else if (type === 'date' || type === 'datetime') {
            value = formatDateToMadridTime(value, true, true);
          }
        }
        filters_params[key] = value;
      }
    }

    // Set sorters
    let sorters_params = {};
    for (const key in sorters) {
      if (!!sorters[key]) {
        sorters_params[key] = sorters[key];
      }
    }

    // Merge filters with hardFilters
    if (!!config.hardFilters) {
      for (const key in config.hardFilters) {
        let value = config.hardFilters[key];
        filters_params[key] = value;
      }
    }

    // Get data
    setIsLoading(true);
    dispatch(actions.getData(filters_params, sorters_params, activePage)).then((response) => {
      setIsLoading(false);
    }, err => {
      setIsLoading(false);
      toast(getToastOpt({
        title: `Error obtenint datos`,
        description: err,
        status: "error",
      }));
    });      
  };

  const handleFilterChange = (evt) => {
    let value;
    const fieldName = evt.currentTarget.name;
    value = evt.currentTarget.value;
    // Set the new filters
    dispatch(actions.setFilters({
      ...filters,
      [fieldName]: value,
    }, isSearcher));
    // Remove selected row
    if (selectedRows.length > 0 && !isMultiRowSelection) {
      dispatch(actions.setSelectedRows([], isSearcher));
    }
  };

  const handleFilteringTimeout = (evt) => {
    if (timeoutFiltering !== null) clearTimeout(timeoutFiltering);
    const timeout = setTimeout(getData, 1000);
    setTimeoutFiltering(timeout);
  };

  const handleOnClickButtonDetail = (datarow) => {
    const primaryValue = datarow[primaryKey];
    const primaryName = datarow[primaryNameKey];
    const _page = page || currentPage;
    const pathKey = defaultDetailPathKey;
    const path = `${_page}/${pathKey}/${primaryValue}`;
    // Add item to breadscrum
    dispatch(mainActions.setBreadscrum(currentPage, [...breadscrum, { path, pathKey, primaryValue, primaryName, itemNameSingular, }]));
    // Goto
    navigate(`/${path}`);
  };

  /*
   * Render
   */

  // Hydrate data
  for (var i = 0; i < data.length; i++) { 
    const datarow = data[i];
    for (const key in datarow) {
      const found = config.columns.find(el => el.name === key);
      if (!!found) {
        let hydrated = false;
        let hydratedValue = null;
        const type = found.header.dataType;
        if (type === 'bool' || type === 'boolean') {
          hydrated = true;
          hydratedValue = datarow[key] ? 'SI' : 'NO';
        } else if (type === 'date') {
          hydrated = true;
          hydratedValue = formatDateToMadridTime(datarow[key], true);
        } else if (type === 'datetime') {
          hydrated = true;
          hydratedValue = formatDateToMadridTime(datarow[key]);
        } else if (type === 'url') {
          hydrated = true;
          hydratedValue = 
            <a 
              href={datarow[key]} 
              target="_blank" 
              rel="noopener noreferrer" 
              // className="maintenance-view-grid-no-decoration"
            >
              {datarow[key]}
            </a>
        } else if (type === 'image') {
          let uri = null;
          if (reducerName === "podcastsReducer") {
            if (key == 'files_2' && !!datarow['url_image_1']) {
              uri = datarow['url_image_1'];
            }
          } else {
            if ((key == 'image_1' || key == 'files_1') && !!datarow['url_image_1']) {
              uri = datarow['url_image_1'];
            } else if ((key == 'image_2' || key == 'files_2') && !!datarow['url_image_2']) {
              uri = datarow['url_image_2'];
            }
          }
          if (!uri) {
            const backend_url = process.env.REACT_APP_BACKEND_URL || '';
            let file_id = datarow[key];
            if (!!file_id) {
              if (reducerName === "newsReducer") {
                if (Array.isArray(file_id) && file_id.length > 0) {
                  file_id = file_id[0];
                  uri = `${backend_url}/files/open/news/${file_id}`;
                }
              } else if (reducerName === "podcastsGroupsReducer") {
                if (Array.isArray(file_id) && file_id.length > 0) {
                  file_id = file_id[0];
                  uri = `${backend_url}/files/open/podcasts_group/${file_id}`;
                }
              } else if (reducerName === "podcastsReducer") {
                if (Array.isArray(file_id) && file_id.length > 0) {
                  file_id = file_id[0];
                  uri = `${backend_url}/files/open/podcasts/${file_id}`;
                }
              } else if (reducerName === "pushNotificationsReducer") {
                if (Array.isArray(file_id) && file_id.length > 0) {
                  file_id = file_id[0];
                  uri = `${backend_url}/files/open/push_notification/${file_id}`;
                }
              } else {
                uri = `${backend_url}/files/open/live/${file_id}`;
              }
            }
          }
          if (!!uri) {
            hydrated = true;
            hydratedValue = (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img 
                  src={uri} 
                  alt="preview" 
                  style={{ height: "auto", width: "100%", borderRadius: "5px" }} 
                  loading="lazy"
                />
              </div>
            );
          }
        } else if (reducerName === "usersReducer" && key === "access_levels") {
          hydrated = true;
          hydratedValue = datarow[key]
                          .split("|")
                          .filter(Boolean) // Elimina elements buits
                          .map(formatAccessLevels) // Aplica formatAccessLevels
                          .join(", ");
        } else if (key === "action_reference_id") {
          hydrated = true;
          hydratedValue = !!datarow[key] ? datarow[key] : "";
        } else if (reducerName === "pushNotificationsReducer" && key === "action") {
          hydrated = true;
          hydratedValue = formatPushNotificationActions(datarow[key]);
        } else if (key === "days_of_week") {
          hydrated = true;
          hydratedValue = datarow[key]
                          .split("|")
                          .filter(Boolean) // Elimina elements buits
                          .map(formatDaysOfWeek) // Aplica formatDaysOfWeek
                          .join(", ");
        }
        if (hydrated) {
          const hydratedProp = key + '_hydrated'
          data[i][hydratedProp] = hydratedValue;
        }
      }
    }
  }

  // Filter data
  const filter = (filterId) => {
    if (!!filters[filterId]) {
      data = data.filter((el) => {
        const hydratedProp = filterId + '_hydrated';
        let item = el[filterId];
        if(el.hasOwnProperty(hydratedProp)){
          item = el[hydratedProp];
        }
        
        // Set filter value
        let filterValue = filters[filterId];
        const found = config.columns.find(el => el.name === filterId);        
        if (!!found) {
          const type = found.header.dataType;
          if (type === 'date' || type === 'datetime') {
            filterValue = formatDateToMadridTime(filterValue, true);
          }
        }

        if (item === null || item === undefined) {  
          item = '';
        }

        return item
          .toString()
          .toLowerCase()
          .includes(filterValue.toString().toLowerCase())
    });
    }
  };
  if (!config.enablePagination) {
    for (const key of config.filters) {
      filter(key);
    }
  }

  // Sorter
  const sorter = (sorterId) => {
    if (!sorters[sorterId]) return;

    const direction = sorters[sorterId]; // 'asc' o 'desc'

    data = data.sort((a, b) => {
      let valA = a[sorterId];
      let valB = b[sorterId];

      // Si és una data (objecte Date o string ISO)
      if (valA instanceof Date || !isNaN(Date.parse(valA))) {
        valA = new Date(valA).getTime();
        valB = new Date(valB).getTime();
      }

      if (valA === valB) return 0;
      if (direction === "asc") return valA > valB ? 1 : -1;
      if (direction === "desc") return valA < valB ? 1 : -1;
      return 0;
    });
  };
  if (!config.enablePagination) {
    for (let i = config.sorters.length - 1; i >= 0; i--) {
      sorter(config.sorters[i]);
    }
  }

  const renderHeaderCell = (
    inputFieldName,
    dataType,
    placeholder,
    textAlign,
    disabled,
  ) => {
    let sx = {
      "::placeholder": {
        color: "white",
      },
      fontSize: "14px",
      padding: "8px", 
    };

    if (!disabled) {
      sx = {
        ...sx, 
        _hover:{
          bg: `hover`,
          borderColor: `white`,
          border: 1,
          borderStyle: "solid",
        },
        _active: {
          bg: 'primary',
          borderColor: `white`,
          border: 1,
          borderStyle: "solid",
        },
        _focus: {
          bg: `primary`,
          borderColor: "white",
          border: 1,
          borderStyle: "solid",
        },
      };
    }

    const value = !!filters[inputFieldName] ? filters[inputFieldName] : ``
    if (!!value) {
      sx = {
        ...sx, 
        bg: `primary`,
        border: 0,
      };
    }
    
    return (
      <HStack spacing="5px">
        {dataType !== 'date' && dataType !== 'datetime' ? 
          <Input
            bg="dark"
            placeholder={placeholder}
            border={0}
            sx={sx}
            name={inputFieldName}
            data-type={dataType}
            textAlign={textAlign}
            onChange={handleFilterChange}
            value={value}
            disabled={disabled}
          />        
        :
          <>
            <DatePicker 
                locale="es"
                dateFormat="dd/MM/yy"
                selected={filters[inputFieldName]} 
                // onSelect={(date) => {                           
                // }} //when day is clicked
                onChange={(date) => {
                    // console.log(`onChange`, date);
                    if (config.enablePagination) {
                      filters[inputFieldName] = date; 
                      handleFilteringTimeout();       
                    } else {
                      dispatch(actions.setFilters({
                        ...filters,
                        [inputFieldName]: date,
                      }, isSearcher));
                    }
                }} 
                customInput={
                  <Input
                    textAlign={textAlign}
                    border={0}
                    sx={sx}
                    value={value}
                  />
                }
                placeholderText={placeholder} 
            />
            <Center 
              color="blue.500" 
              sx={{
                _hover:{
                    color:`white`,
                },
              }}              
              w="15px" 
              cursor="pointer" 
              onClick={() => {
                if (config.enablePagination) {
                  filters[inputFieldName] = null;
                  getData();
                } else {
                  dispatch(actions.setFilters({
                    ...filters,
                    [inputFieldName]: null,
                  }, isSearcher));                  
                }
            }}>
                X
            </Center>                        
          </>  
        }

        {!disabled && (
          <Flex flexDirection="column">
            <Center
              borderRadius="2px"
              h="18px"
              w="15px"
              bg={
                !!sorters[inputFieldName] && sorters[inputFieldName] === `asc`
                  ? `hover`
                  : `dark`
              }
              sx={{
                _hover:{
                    bg: `hover`,
                    borderColor:`white`,
                },
              }}
              mb="1px"
              cursor="pointer"
              onClick={() => {
                dispatch(actions.setSorters({
                  ...sorters,
                  [inputFieldName]:
                    !!sorters[inputFieldName] &&
                    sorters[inputFieldName] === `asc`
                      ? null
                      : `asc`,
                }, isSearcher));
              }}
            >
              <ChevronUpIcon />
            </Center>
            <Center
              borderRadius="2px"
              h="18px"
              w="15px"
              bg={
                !!sorters[inputFieldName] && sorters[inputFieldName] === `desc`
                  ? `hover`
                  : `dark`
              }
              sx={{
                _hover:{
                    bg: `hover`,
                    borderColor:`white`,
                },
              }}
              mt="1px"
              cursor="pointer"
              onClick={() => {
                dispatch(actions.setSorters({
                  ...sorters,
                  [inputFieldName]:
                    !!sorters[inputFieldName] &&
                    sorters[inputFieldName] === `desc`
                      ? null
                      : `desc`,
                }, isSearcher));
              }}
            >
              <ChevronDownIcon />
            </Center>
          </Flex>
        )}
      </HStack>
    );
  };

  const renderGridTitle = () => {
    if (!config.title) return null;
    return (
      <div className="maintenance-view-grid-title">
        {parse(config.title)}
      </div>      
    );
  };

  const renderGridHeader = () => {
    return (
      <Box className="maintenance-view-grid-header">
        <Table variant="simple">
          <Thead>
            <Tr>
              {config.columns.map((row, key) => {
                return (
                  <Th
                    key={"maintenance-view-grid-header-key-" + key}
                    className="maintenance-view-grid-header-row"
                    {...(!!row.width ? { w: row.width } : {})}
                    minWidth={!!row.minWidth ? row.minWidth : defaultMinWidth}
                  >
                    {renderHeaderCell(
                      row.name,
                      row.header.dataType,
                      row.header.placeholder,
                      row.header.textAlign,
                      row.header.disabled,
                    )}
                  </Th>
                );
              })}
              {!isSearcher && config.buttonDetailVisible !== false && <Th
                key={"maintenance-view-grid-header-key-detail"}
                className="maintenance-view-grid-header-row"
                w={eyeColumnWidth}
                maxWidth={eyeColumnWidth}
                minWidth={eyeColumnWidth}
              ></Th>}
            </Tr>
          </Thead>
          <Tbody></Tbody>
        </Table>
      </Box>
    );
  };

  const renderGridBody = () => {

    const hasScrollX = gridRef && gridRef.current && gridRef.current.scrollWidth > gridRef.current.clientWidth;
    let h = sizeGrid.h - 51 - heightPagination;
    if (hasScrollX) {
      h -= 20;
    }

    return (
      <Box className="maintenance-view-grid-body" h={`${h}px`}>
          <Table variant="simple">
            <Thead></Thead>
            <Tbody>
              {data.map((datarow, datakey) => {
                const cellPadding = "10px";
                const marginLeftIcoDetail = "0px";
                const isRowSelected = selectedRows.find((el) => el[primaryKey] === datarow[primaryKey]); 
                let bg = (datakey % 2 === 0) ? "white" : "grid_alternate_row";
                let textColor = "black";

                // Set row height
                const rowStyle = {
                  color: textColor,
                  cursor: datarow['imported'] || !allowSelection ? "default" : "pointer",
                };
                if (reducerName === "liveReducer") {
                  rowStyle["height"] = "130px";
                } else if (reducerName === "newsReducer") {
                  rowStyle["height"] = "85px";
                } else if (reducerName === "podcastsGroupsReducer") {
                  rowStyle["height"] = "105px";
                } else if (reducerName === "podcastsReducer") {
                  rowStyle["height"] = "85px";
                } else if (reducerName === "pushNotificationsReducer") {
                  rowStyle["height"] = "85px";
                }
                return (
                  <Tr
                    key={"maintenance-view-grid-tr-key-" + datakey}
                    bg={bg}
                    className={`maintenance-view-grid-body-row 
                      ${isRowSelected
                        ? "maintenance-view-grid-body-row-selected"
                        : ""
                      }
                    `}
                    style={rowStyle}
                    onClick={(event) => {
                      if (!allowSelection) return;
                      if (datarow['imported']) return;
                      if (isMultiRowSelection) {
                        // In multi-row mode, allow multi-selection only while Ctrl/Cmd is pressed.
                        if (event.ctrlKey || event.metaKey) {
                          if (isRowSelected) {
                            dispatch(actions.removeSelectedRow(datarow[primaryKey], isSearcher));
                          } else {
                            dispatch(actions.addSelectedRow(datarow, isSearcher));
                          }
                        } else {
                          if (isRowSelected && selectedRows.length === 1) {
                            dispatch(actions.setSelectedRows([], isSearcher));
                          } else {
                            dispatch(actions.setSelectedRows([datarow], isSearcher));
                          }
                        }
                      } else {
                        if (isRowSelected) {
                          dispatch(actions.setSelectedRows([], isSearcher));
                        } else {
                          dispatch(actions.setSelectedRows([datarow], isSearcher));
                        }
                      }
                    }}
                  >
                    {config.columns.map((row, key) => {
                      let value = datarow[row.name];
                      const hydratedProp = row.name + '_hydrated';
                      if(datarow.hasOwnProperty(hydratedProp)){
                        value = datarow[hydratedProp];
                      }
                      if (row.header.dataType === 'html') {  
                        value = parse(value)
                      }
                      return (
                        <Td 
                          key={"maintenance-view-grid-td-key-" + datakey + "-" + key}
                          className="maintenance-view-grid-body-column"
                          {...(!!row.width ? { w: row.width } : {})}
                          minWidth={!!row.minWidth ? row.minWidth : defaultMinWidth}
                          style={{
                            ...row.style, 
                          }}
                          p={cellPadding}
                        >                      
                          {value}
                        </Td>
                      );
                    })}
                    {!isSearcher && config.buttonDetailVisible !== false && <Td 
                      key={"maintenance-view-grid-td-key-" + datakey + "-detail"}
                      style={{
                        textAlign: "center",
                      }}
                      w={eyeColumnWidth}
                      minWidth={eyeColumnWidth}
                      onClick={(event) => {
                        event.stopPropagation();
                        handleOnClickButtonDetail(datarow);
                      }}  
                      p={cellPadding}                 
                    >
                      <div style={{marginLeft: marginLeftIcoDetail}}>
                        <IcoDetail size={22} />
                      </div>
                    </Td>}    
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
      </Box>
    );
  };

  const renderPagination = () => {
    if (!config.enablePagination) return null;
    if (sizeGrid.h <= 0) return null;

    const size = "30px";
    const buttonStyle = {
      width: size,
      height: size,
      minWidth: size,
      padding: 0,
    };

    return (
      <Center h={`${heightPagination}px`}>
        <CommonButton 
          onClick={() => {
            setActivePage(1);
          }}
          style={buttonStyle}
          inverted={true}
        >
          <ChevronLeftIcon />
          <ChevronLeftIcon ml="-10px"/>
        </CommonButton>
        <CommonButton onClick={() => {
            if (activePage > 1 ) setActivePage(activePage - 1);
          }}
          style={{...buttonStyle, marginLeft: "5px"}}
          inverted={true}
        >
            <ChevronLeftIcon />
        </CommonButton>
        <Text ml="5px">
            {/* 1 .. */}
        </Text>
        <Text ml="5px" color="dark" fontSize="14px">
            Pág. {activePage} de {numberOfPages}
        </Text>
        <Text ml="5px">
            {/* .. {numberOfPages} */}
        </Text>
        <CommonButton onClick={() => {
            if (activePage < numberOfPages ) setActivePage(activePage + 1);
          }}
          style={{...buttonStyle, marginLeft: "5px"}}
          inverted={true}
        >
            <ChevronRightIcon />
        </CommonButton>
        <CommonButton onClick={() => {
            setActivePage(numberOfPages);
          }}
          style={{...buttonStyle, marginLeft: "5px"}}
          inverted={true}
        >
            <ChevronRightIcon />
            <ChevronRightIcon ml="-10px"/>
        </CommonButton>
    </Center>
    );
  };

  const renderClearFilter = () => {
    if (isSearcher) return null;
    if (!filters || Object.keys(filters).length === 0) return null;
    let anyFilter = false;
    for (const key in filters) {
      if (!!filters[key]) {
        anyFilter = true;
        break;
      }
    }
    if (!anyFilter) return null;

    return (
      <div className="maintenance-view-grid-clear-filter" onClick={() => {
        dispatch(actions.setFilters({}, isSearcher));
      }}>
        <IcoClearFilter size={22} />
      </div>
    );
  };

  // Finally.. Render
  return (
    <div className="maintenance-view-grid-wrapper" style={config.marginTop !== undefined ? {marginTop: config.marginTop} : {}}>
      { config.floatComponent && (
        config.floatComponent
      )}      
      <div className="maintenance-view-grid-top">
        <div className="maintenance-view-grid-title-wrapper">
          {renderGridTitle()}
        </div>
      </div>
      <div className="maintenance-view-grid-parent" ref={gridParentRef}>   
        {renderClearFilter()}
        <div className="maintenance-view-grid" style={config.fullScreen === false ? {} : {width: sizeGrid.w}} ref={gridRef}>
          {renderGridHeader()}
          {renderGridBody()}
        </div>
        {renderPagination()}
      </div>
    </div>
  );
};

export default MaintenanceViewGrid;
